import {dayjs, ElMessage} from "element-plus";
import axiosApi from "@/utils/axiosApi";
import store from "@/store";

export const copyText = (text) => {
    const textarea = document.createElement('textarea');
    // 设置相关属性
    textarea.readOnly = 'readonly';
    textarea.style.position = 'fixed';
    textarea.style.top = '-99999px';
    // 把目标内容赋值给它的value属性
    textarea.value = text;
    // 插入到页面
    document.body.appendChild(textarea);
    // 调用onselect()方法
    textarea.select();
    const res = document.execCommand('Copy');
    document.body.removeChild(textarea);
    ElMessage({
        type: res ? "success" : "error",
        message: res ? "复制成功" : "复制失败"
    })
}

export const dateFormat = (date) => {
    return dayjs(date).format('YYYY年M月D日')
}

export const xm_air_login = (data, success, fail) => {
    new axiosApi({
        encode: 'site',
        method: 'user/xm_user_info',
        body: {
            access_token: data.access_token, user_id: data.user_id
        }
    }).send((r) => {
        if (r.message.code !== "000") {
            store.commit("removeAccount")
            if (fail) {
                return fail(r)
            }
            return ElMessage.error(r.message.content)
        }
        r.data.access_token = data.access_token
        r.data.user_id = data.user_id
        r.data.loginType = "xm_air"
        store.commit("setAccount", r.data)
        if (success) {
            return success(r)
        }
    }, () => {
        store.commit("removeAccount")
        if (fail) {
            return fail(r)
        }
    })
}

export const scal_login = (data, success, fail) => {
    new axiosApi({
        encode: "site",
        method: "user/check_login",
        body: {
            cust_id: data.cust_id,
            token: data.token
        }
    }).send((res) => {
        if (res.message.code !== "000") {
            store.commit("removeAccount")
            if (fail) {
                return fail(res)
            }
            return ElMessage.error(res.message.content)
        }

        res.data.loginType = "scal"
        store.commit("setAccount", res.data)
        if (success) {
            return success(res)
        }
    });
}
